import { useEffect } from "react";
import { StyledCaptcha } from "./style";

const CAPTCHA_ID = "captcha-canv";

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

export const Captcha = ({ captcha }) => {
  useEffect(() => {
    console.log("generate");
    generateCaptcha();
  }, [captcha]);

  function generateCaptcha() {
    var c = document.getElementById(CAPTCHA_ID);
    var ctx = c.getContext("2d");
    ctx.font = "16px Arial";
    ctx.save();
    ctx.clearRect(0, 0, 800, 600);

    for (var i = 0; i < captcha.length; i++) {
      ctx.translate(10 + i * 25, 18);
      ctx.rotate(getRandom(-0.3, 0.3));
      ctx.fillText(captcha[i], 0, 0);
      ctx.restore();
      ctx.save();
    }
    //setCaptcha(tmpCaptcha.join(""));
    //var specialData = document.getElementById("specialData");
    //specialData.value = captcha.join("");
  }

  return (
    <StyledCaptcha>
      <div>Sicherheitscode:</div>
      <canvas id={CAPTCHA_ID} width="155" height="24"></canvas>
    </StyledCaptcha>
  );
};
